export default "__VITE_ASSET__yK4AGQI2OZk7MdRgobs9JA__"